/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
/**
 * useLocalAI — hook React sullo stato del motore AI locale (localLLM.js).
 */
import { useEffect, useState } from 'react';
import { localLLM } from '@/lib/localLLM';

export const useLocalAI = ({ autoInit = true } = {}) => {
  const [state, setState] = useState(localLLM.getState());
  useEffect(() => localLLM.subscribe(setState), []);
  useEffect(() => { if (autoInit) localLLM.init(); }, [autoInit]);
  return { ...state, engine: localLLM };
};

export default useLocalAI;
